var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBulb = function SvgBulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 12 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 2a4 4 0 0 0-2.4 7.2.998.998 0 0 1 .103.09 4.5 4.5 0 0 1 .585.71H5V8a1 1 0 1 1 2 0v2h.712a4.5 4.5 0 0 1 .585-.71.998.998 0 0 1 .103-.09A4 4 0 0 0 6 2Zm-3.163 9.505a.997.997 0 0 1-.077-.163 2.5 2.5 0 0 0-.422-.589 6 6 0 1 1 7.324 0 2.5 2.5 0 0 0-.422.59.997.997 0 0 1-.076.161 2.5 2.5 0 0 0-.175 1.35A1 1 0 0 1 9 13a3 3 0 1 1-6 0 1 1 0 0 1 .01-.146 2.5 2.5 0 0 0-.173-1.35Zm4.161 1.552A4.5 4.5 0 0 1 6.988 12H5.012a4.5 4.5 0 0 1-.01 1.057 1 1 0 0 0 1.997 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgBulb;